import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';
import Spinner from '../Spinner';
import { IframeWrapper, IframeStyle } from './style';

interface IProps {
  source: string;
  title: string;
  children: ReactNode;
}

const Frame: FC<IProps> = ({ source, title, children }) => {
  const formRef = useRef<HTMLFormElement | null>(null);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (formRef.current && formRef.current.submit instanceof Function) {
      formRef.current.submit();
    }

    setInterval(() => {
      const iframe = document.querySelector('iframe') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ action: 'height' }, '*');
      }
    }, 1000);

    window.addEventListener('resize', () => {
      const iframe = document.querySelector('iframe') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ action: 'height' }, '*');
      }
    });

    window.addEventListener('message', ({ data }) => {
      const iframe = document.querySelector('iframe') as HTMLIFrameElement;
      const { height } = data;
      if (iframe) iframe.style.height = height;
    });
  }, [formRef]);

  return (
    <IframeWrapper>
      {isLoading && <Spinner />}
      <form
        data-testid="frame-form"
        target="myFrame"
        action={source}
        method="POST"
        ref={formRef}
      >
        {children}
      </form>
      <IframeStyle
        onLoad={() => setIsLoading(false)}
        data-testid="frame-iframe"
        name="myFrame"
        title={title}
      />
    </IframeWrapper>
  );
};

export default Frame;
